import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_CHANNEL_ACTIVATION,
  CREATE_CHANNEL_ACTIVATION_FAILURE,
  CREATE_CHANNEL_ACTIVATION_SUCCESS,
  FETCH_CHANNELS
} from 'src/redux/integrationsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

interface CreateChannelActivationAction {
  payload: {
    channel_id: number
    login: string
    password: string
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateChannelActivationFlow(action: CreateChannelActivationAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    yield call(apiCall, {
      endpoint: '/dealers_api/channel_activations',
      api: 'market-api',
      method: POST,
      params: { channel_activation: action.payload }
    })
    yield put(CREATE_CHANNEL_ACTIVATION_SUCCESS())
    yield put(SHOW_TOAST({ message: t('integrations_screen.connect_success') }))
    yield put(FETCH_CHANNELS())
  } catch (error) {
    yield put(CREATE_CHANNEL_ACTIVATION_FAILURE())
    yield put(SHOW_TOAST({ message: t('integrations_screen.connect_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateChannelActivationSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_CHANNEL_ACTIVATION, CreateChannelActivationFlow)
}
